import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { CountryViewModel, SettingsViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { trackException } from '@fora-monorepo/webapp-analytics';

import { envConfig } from '../../config';
import { createThunkError } from '../utils';
import { mockCountries, mockSettings } from './mocks';

export const getCountries = createAsyncThunk('getCountries', async (_, thunkAPI) => {
  if (envConfig.mockDataFrontend) {
    return mockCountries;
  }

  return axios
    .get(`${envConfig.bffBaseUri}/fora-global/countries`)
    .then(res => {
      if (res.status === 200) {
        return res.data as CountryViewModel[];
      }
    })
    .catch(err => {
      trackException(err);
      return thunkAPI.rejectWithValue(createThunkError('Could not get countries', err));
    });
});

export const getSettings = createAsyncThunk('getSettings', async (_, thunkAPI) => {
  if (envConfig.mockDataFrontend) {
    return mockSettings;
  }

  return axios
    .get(`${envConfig.bffBaseUri}/fora-global/settings`)
    .then(res => {
      if (res.status === 200) {
        return res.data as SettingsViewModel;
      }
    })
    .catch(err => {
      trackException(err);
      return thunkAPI.rejectWithValue(createThunkError('Could not get settings', err));
    });
});
